<app-new-note [moduleId]="moduleId" [entityId]="clientId" [breadCrumbInputs]="breadCrumbInputs"></app-new-note>